import { render, staticRenderFns } from "./SkillButtonOverlay.vue?vue&type=template&id=21c413c0&"
import script from "./SkillButtonOverlay.vue?vue&type=script&lang=ts&"
export * from "./SkillButtonOverlay.vue?vue&type=script&lang=ts&"
import style0 from "./SkillButtonOverlay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports